module.exports = __webpack_public_path__ + "static/img/31.f6e77e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/31.png
// module id = usOV
// module chunks = 0